import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./programBanner.scss";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
import useQueryParams from "../../../../hooks/useQueryParams";
function ProgramBanner(props) {
  const { banner, type, Link } = props;
  const queryParams = useQueryParams();
  const [UTM_PATAMS_1, setUTM_PATAMS_1] = useState('')
  const [UTM_PATAMS_2, setUTM_PATAMS_2] = useState('')
  useEffect(() => {
    setUTM_PATAMS_1(getQueryUTMString("&"))
    setUTM_PATAMS_2(getQueryUTMString("?"))
  }, [queryParams])
  const NextLink = Link || "a";
  if (!banner) {
    return null;
  }
  return (
    <div className={`${styles["wrapper"]} ${styles[type]}`}>
      <div className={styles["image-wrapper"]}>
        <img src={banner.image} />
      </div>
      <div
        className={styles["description-wrapper"]}
        style={{ backgroundColor: banner.backgroundColor }}
      >
        <div className={styles["info"]} style={{ color: banner.textColor }}>
          <h2 className={styles["title"]} title={banner?.title}>
            {banner.title}
          </h2>
          <p className={styles["description"]} title={banner?.description}>
            {banner.description}
          </p>
        </div>
        <div className={styles["actions"]}>
          <a
            href={
              banner?.detailsPageUrl
                ? `/page?url=${banner?.detailsPageUrl}${UTM_PATAMS_1}`
                : ""
            }
            target="_blank"
            rel="noreferrer"
          >
            <div className={styles["details-link"]}>
              <span
                className={styles["text"]}
                style={{ color: banner.textColor }}
              >
                活動詳情
              </span>
              <div className={styles["arrow"]}>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill={banner.textColor || "#ffff"}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M3.8421 15.7425L15.5756 8.62178C16.1415 8.27836 16.1415 7.72161 15.5756 7.37822L3.8421 0.257542C3.27626 -0.0858472 2.35884 -0.0858472 1.79294 0.257542L0.424418 1.08805C-0.140538 1.4309 -0.141599 1.98654 0.422 2.33018L9.72101 7.99998L0.422 13.6698C-0.141599 14.0135 -0.140538 14.5691 0.424418 14.9119L1.79294 15.7425C2.35878 16.0858 3.2762 16.0858 3.8421 15.7425Z" />
                </svg>
                {/* <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.37089 11.3229L7.32097 6.42747C7.55968 6.19137 7.55968 5.8086 7.32094 5.57253L2.37089 0.67706C2.13217 0.44098 1.74514 0.44098 1.5064 0.67706L0.929051 1.24804C0.690711 1.48375 0.690263 1.86575 0.928031 2.102L4.85105 5.99999L0.928031 9.898C0.690263 10.1343 0.690711 10.5163 0.929051 10.752L1.5064 11.3229C1.74511 11.559 2.13215 11.559 2.37089 11.3229Z"
                      fill="#fff"
                    />
                  </svg> */}
              </div>
            </div>
          </a>

          <div className={styles["button-wrapper"]}>
            <NextLink
              href={
                banner.urlType === 'link_out_url_buy_now'
                  ? banner.customizedLinkOutBuyNow.includes("?") ? `${banner.customizedLinkOutBuyNow}${UTM_PATAMS_1}` : `${banner.customizedLinkOutBuyNow}${UTM_PATAMS_2}`
                  : banner.promotionCode.includes("?") ? `/promotions/${banner.promotionCode}${UTM_PATAMS_1}` : `/promotions/${banner.promotionCode}${UTM_PATAMS_2}`
              }
              passHref
            >
              {/* <a> */}
              <a className={styles["button"]}>立即選購</a>
              {/* </a> */}
            </NextLink>
          </div>
        </div>
      </div>
    </div>
  );
}

ProgramBanner.propTypes = {
  banner: PropTypes.object,
  type: PropTypes.oneOf(["tier1", "tier2"]),
};

export default ProgramBanner;
